import { OptionType } from '@evinced-private/ui-common';

import { ENVIRONMENT_LABEL_KEY, UNIT_ID_LABEL_KEY } from 'src/common/consts/platformConfigConsts';
import { markOptionsWithWarnings } from 'src/common/helpers/ConfigurationWarningsHelper';

interface ConfiguredValues {
	environment: Set<string>;
	unitId: Set<string>;
	environmentDisplayName: string;
	unitIdDisplayName: string;
}

export const applyWarningsToValueOptions = (
	options: OptionType[],
	labelKey: string | undefined,
	configuredValues: ConfiguredValues,
	extractValueFromLabel?: (label: string) => string
): OptionType[] => {
	if (!labelKey) {
		return options;
	}

	const labelKeyLower = labelKey.toLowerCase().trim();

	if (labelKeyLower === ENVIRONMENT_LABEL_KEY.toLowerCase()) {
		return markOptionsWithWarnings(
			options,
			configuredValues.environment,
			configuredValues.environmentDisplayName,
			extractValueFromLabel
		);
	}

	if (labelKeyLower === UNIT_ID_LABEL_KEY.toLowerCase()) {
		return markOptionsWithWarnings(
			options,
			configuredValues.unitId,
			configuredValues.unitIdDisplayName,
			extractValueFromLabel
		);
	}

	return options;
};
